/**
 * Dispatches a custom event. The event bubbles and cannot be canceled.
 *
 * Notes:
 * - For typing, event names are registered in src/models/Event.ts
 * - Does not need to be a custom hook because it does not need to access React features like state.
 *
 * Example:
 * ```
 * const payload: MyPayload = { ... }
 * dispatchCustomEvent<MyPayload>(EVENT.MY_EVENT, payload)
 * dispatchCustomEvent(EVENT.MY_OTHER_EVENT)
 * ```
 */
export const dispatchCustomEvent = (eventName, payload = {}) => {
  if (typeof document === 'undefined') return;
  document.dispatchEvent(new CustomEvent(eventName, {
    detail: payload,
    bubbles: true
  }));
};